<script>
import {ref} from "vue";
import useSharedData from "@/use/SharedData.js";
import useValidation from "@/use/Validation.js";
import useSharedMethod from "@/use/SharedMethod.js";
import useTools from "@/use/Tools.js";
import {usePaySlipStore} from "@/stores/PaySlip";
import axios from "axios";

export default {
    setup() {
        const paySlipStore = usePaySlipStore();
        const {mxRules} = useValidation();
        const {getBack, transformFilterValues} = useSharedMethod();
        const {loading, dialog} = useSharedData();
        const {$route} = useTools();
        const tagId = ref(null);
        
        function create() {
            loading.value = true;
            axios.post(`/payments/createEmptyOne`, null, {
                params: transformFilterValues({
                    tagId: tagId.value,
                    workerId: $route.params.workerId,
                    annexId: $route.params.annexId
                })
            }).then(response => {
                paySlipStore.addPaySlip(response.data);
                getBack();
            }).finally(() => {
                loading.value = false;
            });
        }
        
        return {
            mxRules,
            loading,
            dialog,
            tagId,
            create,
            getBack,
        }
    },
}
</script>

<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="600"
        scrollable
    >
        <v-card>
            <w-toolbar color="teal" :title="$t('pay_slip.create_empty_bis')"/>
            <v-card-text>
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="12">
                            <strong>TAG *</strong>
                            <w-data-select-autocomplete
                                v-model="tagId"
                                type="PAY_SLIP_TAG"
                                :rules="[mxRules.required]"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-add
                    show
                    :loading="loading"
                    @press="create"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>